(function() {
  var Router,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Router = App.loadClass('core::Router');

  exports.DaystoharvestRouter = (function(superClass) {
    extend(DaystoharvestRouter, superClass);

    function DaystoharvestRouter() {
      return DaystoharvestRouter.__super__.constructor.apply(this, arguments);
    }

    DaystoharvestRouter.prototype.prefix = 'Daystoharvest';

    DaystoharvestRouter.prototype.module_name = 'DaystoharvestRouter';

    DaystoharvestRouter.prototype.register = function() {
      this.module = angular.module(this.module_name, ['ui.router', 'ui.bootstrap']);
      this.service('portal::Angular/Daystoharvest/DaystoharvestService', ['$http', '$rootScope', '$window']);
      return this.controller('portal::Angular/Daystoharvest/DaystoharvestController', ['$scope', '$transitions', 'Days', 'Daystoharvest.Services.DaystoharvestService', 'Core.Services.Loading']);
    };

    DaystoharvestRouter.prototype.registerRoutes = function($stateProvider) {
      return $stateProvider.state('portal.daystoharvest', {
        url: '/daystoharvest',
        templateUrl: 'backend/portal/daystoharvest/ng-sidebar',
        controller: [
          '$scope', '$state', function($scope, $state) {
            $scope.show_fullpage = true;
            return $state.go('portal.daystoharvest.dialog');
          }
        ]
      }).state('portal.daystoharvest.dialog', {
        url: '/dialog',
        views: {
          fullpage: {
            templateUrl: 'backend/portal/daystoharvest/ng-dialog',
            controller: 'Daystoharvest.Controllers.DaystoharvestController'
          }
        },
        resolve: {
          'Days': [
            'Daystoharvest.Services.DaystoharvestService', (function(_this) {
              return function(repository) {
                return repository.fetch().then(function(response) {
                  var jsr;
                  jsr = response.data;
                  return jsr;
                });
              };
            })(this)
          ]
        }
      });
    };

    return DaystoharvestRouter;

  })(Router);

}).call(this);
